import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';
import { CORE_CONFIG } from '../environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  private _baseURL: string;

  constructor(private httpClient: HttpClient,
    @Inject(CORE_CONFIG) private coreConfig: any) {
    this._baseURL = this.coreConfig.endpoint;
  }

  upload(path: string, formData: FormData): Observable<any> {
    return this.httpClient.post(`${this._baseURL}${path}`, formData);
  }
}
